import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { PlusOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { getactionMessages } from '../../constants/messages';
import AddCreditNoteModal from './AddCreditNoteModal';

let messages = getactionMessages();

class AddCreditNoteButton extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			showModal: false,
		};
	}

	openModal = () => {
		this.setState({
			showModal: true,
		});
	};

	closeModal = () => {
		this.setState({
			showModal: false,
		});
	};

	render() {
		return (
			<span>
				<Button className="editable-add-btn" type="primary" onClick={this.openModal}>
					<PlusOutlined />
					<FormattedMessage {...messages.add} />
				</Button>
				<AddCreditNoteModal showModal={this.state.showModal} handleCancel={this.closeModal} />
			</span>
		);
	}
}

export default injectIntl(AddCreditNoteButton);
